export default __webpack_public_path__ + "static/media/YAS0040.34I-27643_-16582_0.a4e500a2.jpg";